import React, { useContext, useState, useEffect } from 'react'
import { SmartContract, ThirdwebSDK } from '@thirdweb-dev/sdk'
import { useAccount, useWalletClient } from 'wagmi'
import { useChain } from '@thirdweb-dev/react'
import { BlockchainData, blockchainData } from 'constants/DragonsHolder'
import { ChainDropDown } from './ChainDropDown'
import Tokens from './Tokens'
import { BaseContract, ethers } from 'ethers'
import NFTCABI from '../../ABI/NFTCABI.json'
import BridgeABI from '../../ABI/BridgeABI.json'
import useFetchFee from 'hooks/useFetchFee'
import LoadingSpinner from 'components/common/LoadingSpinner'
import { useEthersProvider, useEthersSigner } from 'utils/ethers'

const BridgeComponent = () => {
  //#TODO: Setup component foundation
  //Get signed in wallet *
  //Get source chain *
  //Get dest chain *
  //Get owned NFT's from source Chain *

  //#TODO: PreChecks to Prep for Bridge
  //Create the transfer function
  //1:Get Dest chain *
  //2:Get TokenId
  //3:Get Owner of source and dest for the tokenID
  //4:If tokenID !Exists Bridge Mint the NFT --Estimate Gas *
  //5:Approve the Bridge address to transact on the Collection @ dest --Estimate Gas *
  //6:Transfer NFT to custody (retainNew) @ dest --Estimate Gas *
  //7:if Source chain owner != signed in wallet update holder address

  //#TODO: Start Bridging process
  //0.5: Check if Bridge is approved to transfet the NFT
  //1:Approve Bridge approval for all on source contract --User Approve and pay Gas
  //1.5 //Add gas estimates for Bridging fee +5%
  //2.0: If Custom Token
  //      --check Balance
  //      --ApproveCustody to transfer
  //      --RetainNFTC
  //2.5: If Native
  //      --retainNFTN
  //3: Release dest NFT
  //4: Refresh Source NFTs
  const [status, setStatus] = useState('')
  const [customPay, setCustomPay] = useState(false)
  let sourceSDK = new ThirdwebSDK('sepolia')
  let destSDK = new ThirdwebSDK('mumbai')
  const [collectionContract, setCollectionContract] =
    useState<SmartContract<BaseContract>>()
  const [bridgeContract, setBridgeContract] =
    useState<SmartContract<BaseContract>>()
  const { address } = useAccount()
  const signer = useEthersSigner()
  const _chain = useChain()
  const [sourceChain, setSourceChain] = useState<BlockchainData | null>(null)
  const [destinationChain, setDestinationChain] =
    useState<BlockchainData | null>(null)
  const [tokenId, setTokenId] = useState<number | undefined>(undefined)
  const {
    data: feeData,
    isLoading: feeLoading,
    error: feeError,
  } = useFetchFee(sourceChain?.chain, destinationChain?.chain, tokenId)

  useEffect(() => {
    if (destinationChain) {
      sourceSDK = new ThirdwebSDK(destinationChain?.chain)
      setTokenId(2)
    }
  }, [destinationChain])

  async function createBridgeToken(tokenId: string, minting: boolean) {
    let res = ''
    const response = await fetch('/api/bridge/init', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        tokenId: tokenId,
        chain: destinationChain?.chain,
        mint: minting,
      }),
    })

    if (!response.ok) {
      res = 'Failed'
    } else {
      res = await response.json()
    }
    return res
  }
  async function updateBridgeOwner(tokenId: string, _to: string) {
    let res = ''
    const response = await fetch('/api/bridge/updateowner', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        tokenId: tokenId,
        chain: destinationChain?.chain,
        to: _to,
      }),
    })

    if (!response.ok) {
      res = 'Failed'
    } else {
      res = await response.json()
    }

    return res
  }
  async function releaseNFT(tokenId: string, _to: string) {
    let res = ''
    const response = await fetch('/api/bridge/release', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        tokenId: tokenId,
        chain: destinationChain?.chain,
        to: _to,
      }),
    })

    if (!response.ok) {
      res = 'Failed'
    } else {
      res = await response.json()
    }

    return res
  }
  async function bridgeChecks() {
    setStatus('Initializing Transfer...')
    //Get owners of source and dest tokens
    //if Source chain owner != signed in wallet update holder address
    const sourceCollection = await sourceSDK.getContract(
      sourceChain?.collectionAddress!
    )
    const destCollection = await destSDK.getContract(
      destinationChain?.collectionAddress!
    )
    const sourceBridge = await sourceSDK.getContract(
      sourceChain?.bridgeAddress!
    )
    const sourceOwner = await sourceCollection.call('ownerOf', [tokenId])
    const destOwner = await destCollection
      .call('ownerOf', [tokenId])
      .catch(async (error) => {
        console.log('Token does not exist on dest chain...')
      })
    await destCollection.call('ownerOf', [tokenId]).catch(async (error) => {
      if (error) {
        const res = await createBridgeToken(tokenId!.toString(), true)
        console.log(res)
      } else if (destOwner == '0x0f3d7a590C99ceD611ebc659704D440e923d5694') {
        const res = await createBridgeToken(tokenId!.toString(), false)
        console.log(res)
      }
    })
    if (sourceOwner == address) {
      const bridgeHolder = await sourceBridge.call('getCustody', [tokenId])
      const unListed = '0x0000000000000000000000000000000000000000'
      if (bridgeHolder == sourceOwner) {
        console.log('Owner Confirmed')
      } else if (bridgeHolder == unListed) {
        console.log('Owner Confirmed')
      } else {
        //Update the owner
        const bridgeUpdate = await updateBridgeOwner(
          tokenId!.toString(),
          address!
        )
        console.log(bridgeUpdate)
        console.log(`Updated Bridge holder to: ${address}`)
      }
    }
  }

  async function bridgeTokens() {
    const provider = useEthersProvider()
    await bridgeChecks();
    setStatus('Veryfying details...')
    sourceSDK.updateSignerOrProvider(provider)
    const sourceCollection = await sourceSDK.getContract(
      sourceChain?.collectionAddress!
    )
    const sourceBridge = await sourceSDK.getContract(
      sourceChain?.bridgeAddress!
    )
    const sourceToken = await sourceSDK.getContract(sourceChain?.tokenAddress!)
    const approved = await sourceCollection.erc721.isApproved(
      address!,
      sourceChain?.bridgeAddress!
    )
    if (!approved) {
      const tx1 = (
        await sourceCollection.erc721.setApprovalForAll(
          sourceChain?.bridgeAddress!,
          true
        )
      ).receipt
      console.log(`Bridge approved ${tx1}`)
    }
    setStatus('Please approve tokens to bridge')
    const bridgingFee = ethers.utils.parseUnits(feeData?.bridgingFee!, 'ether')
    if (customPay) {
      //Pay with custom ERC20 token
      //TODO: Create a function to estimate the bridging fee in ERC20 Tokens
      const tx2 = (
        await sourceToken.erc20.setAllowance(
          sourceChain?.bridgeAddress!,
          bridgingFee.toString()
        )
      ).receipt
      const tx3 = await sourceBridge.call('retainNFTC', [
        tokenId,
        bridgingFee,
        process.env.HASH,
      ])
    } else {
      //Pay with Native
      const tx3 = await sourceBridge.call('retainNFTN', [
        tokenId,
        bridgingFee,
        process.env.HASH,
      ])
    }
    setStatus(
      `Transferring to destination via: ${capitalizeFirstLetter(
        destinationChain?.chain!
      )}`
    )
    const releaseRes = await releaseNFT(tokenId!.toString(), address!)
    //Refresh tokens
  }

  function capitalizeFirstLetter(string: string) {
    return string.charAt(0).toUpperCase() + string.slice(1)
  }

  return (
    <div className="flex flex-col space-y-4 mt-4 p-4 border-2 border-primary rounded-xl w-full">
      <div className="flex flex-row">
        <div className="flex flex-col flex-auto">
          <p>Source Chain:</p>
          <ChainDropDown
            primary={true}
            blockchainData={blockchainData}
            onSelect={setSourceChain}
            selectedChain={sourceChain}
          />
        </div>
        <div id="arrowAnim" className='mx-2 mt-5'>
          <div className="arrowSliding">
            <div className="arrow"></div>
          </div>
          <div className="arrowSliding delay1">
            <div className="arrow"></div>
          </div>
          <div className="arrowSliding delay2">
            <div className="arrow"></div>
          </div>
          <div className="arrowSliding delay3">
            <div className="arrow"></div>
          </div>
        </div>
        <div className="flex flex-col flex-auto">
          <p>Destination Chain:</p>
          <ChainDropDown
            blockchainData={blockchainData}
            onSelect={setDestinationChain}
            selectedChain={destinationChain}
          />
        </div>
      </div>
      {_chain && <Tokens selectedToken={tokenId} setTokenId={setTokenId} />}
      <div>
        Bridging fee:
        {feeData === null && feeLoading ? (
          <LoadingSpinner
            css={{ height: '20px', width: '20px', marginLeft: '10px' }}
          />
        ) : feeData !== null ? (
          ` ~${Number(feeData.bridgingFee).toFixed(6)} ${
            sourceChain?.currency
          } $${feeData.usd}`
        ) : (
          ''
        )}
      </div>
      <div className="flex items-center space-x-4">
      <input
        type="checkbox"
        id="checkbox"
        checked={customPay}
        onChange={() => setCustomPay(!customPay)}
        className="form-checkbox h-5 w-5 text-primary"
      />
      <label htmlFor="checkbox" className="text-gray-700">
        Bridge with DiJT token
      </label>
      </div>
      <button onClick={()=>bridgeTokens} className="h-10 w-40 bg-primary rounded-xl">Bridge Token</button>
    </div>
  )
}

export default BridgeComponent
